import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

import Header from '@components/Header';

import { validatePermissionAction } from '@actions/sessionPermission';
import {
  getReportTotalFoliosPRGEH, getReportTotalFoliosPDD, getReportTotalFoliosPCI,
  getReportTotalFoliosPDDC, reportTotalPRGEH, reportDetailPRGEH, reportDetailPDD,
  reportDetailPDDC, reportDetailPCI
} from '@actions/users';

import { TypeProcess } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import classNames from 'classnames'

class ReportsProces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      loadingBtn1: false,
      loadingBtn2: false,
      typeProcess: null,
      fullData: [],
      data: [],
      lazyParams: {
        first: 0,
        rows: 7,
        page: 0,
      },
      typeCountry: null,
      countryRequired: false,
      from: '',
      monthRequired: false,
      searchValues: {
        countryName: null,
        country: null,
        monthYear: '',
      }
    };
    this.typeProcessOptions = [
      { label: this.props.t('Debida Diligencia'), id: TypeProcess.PDD },
      { label: this.props.t('Debida Diligencia Completo'), id: TypeProcess.PDDC },
      { label: this.props.t('Conflicto de Interés'), id: TypeProcess.PCI },
      // {label: 'Devolución de Regalos', id: 2},
      // {label: 'Gastos de Hospitalidad', id: 3},
      { label: this.props.t('Regalos y Gastos de Entretenimiento'), id: TypeProcess.PRGEH },
      // {label: 'Debida Diligencia Completo', id: 5}
    ]
  }

  async componentDidMount() {
    this.onChangeProcess({ target: { name: 'typeProcess', value: this.typeProcessOptions[0] } })
    await this.loadData();
  }

  loadData = async () => {
    const { getReportTotalFoliosPRGEH, getReportTotalFoliosPDD, getReportTotalFoliosPCI, getReportTotalFoliosPDDC } = this.props;
    const { typeProcess, searchValues } = this.state;
    this.setState({ loadingTable: true });
    let response = null
    if (typeProcess?.id === TypeProcess.PDD) {
      console.log("    Consulta de reporte PDD");
      response = await getReportTotalFoliosPDD();
    }
    if (typeProcess?.id === TypeProcess.PDDC) {
      console.log("    Consulta de reporte PDDC");
      response = await getReportTotalFoliosPDDC();
    }

    if (typeProcess?.id === TypeProcess.PCI && searchValues?.country != '' && searchValues.monthYear != '') {
      console.log("    Consulta de reporte PCI");
      console.log("   searchValues.country: " + searchValues.country);
      console.log("   searchValues.monthYear: " + searchValues.monthYear);

      const querys = {
        country: searchValues.country,
        contryName: searchValues.countryName,
        monthYear: searchValues.monthYear,
      }
      response = await getReportTotalFoliosPCI(querys);
    }

    if (typeProcess?.id === TypeProcess.PRGEH) {
      console.log("    Consulta de reporte PRGEH");
      response = await getReportTotalFoliosPRGEH();
    }

    if (!response?.status) {
      return this.setState({
        fullData: response.data,
        data: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  onTotalPRGEH = async () => {
    const { reportTotalPRGEH } = this.props;
    this.setState({ loadingBtn1: true });
    await reportTotalPRGEH();
    this.setState({ loadingBtn1: false });
  };

  onDetailPRGEH = async () => {
    const { reportDetailPRGEH } = this.props;
    this.setState({ loadingBtn2: true });
    await reportDetailPRGEH();
    this.setState({ loadingBtn2: false });
  };

  onDetailPDD = async () => {
    const { reportDetailPDD } = this.props;
    this.setState({ loadingBtn1: true });
    await reportDetailPDD();
    this.setState({ loadingBtn1: false });
  };

  onDetailPDDC = async () => {
    const { reportDetailPDDC } = this.props;
    this.setState({ loadingBtn1: true });
    await reportDetailPDDC();
    this.setState({ loadingBtn1: false });
  };

  onDetailPCI = async () => {
    const { reportDetailPCI } = this.props;
    const { searchValues } = this.state;
    console.log(searchValues);

    this.setState({ loadingBtn1: true });
    const querys = {
      countryName: searchValues.countryName,
      country: searchValues.country,
      monthYear: searchValues.monthYear,
    }
    await reportDetailPCI(querys);
    this.setState({ loadingBtn1: false });
  };

  onChangeProcess = ({ target }) => {
    this.setState({
      [target.name]: target.value,
      data: [],
      lazyParams: {
        first: 0,
        rows: 7,
        page: 0,
      }
    }, async () => {
      await this.loadData();
    });

  };

  loadDataByPage = () => {
    const { lazyParams, fullData } = this.state
    const dataPage = fullData.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ data: dataPage })
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  columnResponsive = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      {rowData[detail.field]}
    </>
  )

  searchData = () => {
    const { from, typeCountry } = this.state
    if (!typeCountry) return this.setState({ countryRequired: true })
    if (!from) return this.setState({ monthRequired: true })

    let selectedDate = new Date(from);
    let selectedMonth = ((selectedDate.getMonth() + 1) < 10) ? "0" + (selectedDate.getMonth() + 1) : (selectedDate.getMonth() + 1)
    let selectedYear = selectedDate.getFullYear()
    let selectedFinalValue = selectedMonth + "-" + selectedYear

    this.setState({
      searchValues: {
        countryName: typeCountry?.label,
        country: typeCountry?.id || '',
        monthYear: selectedFinalValue || '',
      }
    }, async () => {
      await this.loadData()
    })
  }

  onChangeCountry = ({ target }) => {
    this.setState({ [target.name]: target.value }, () => {
      if (target.name === "typeCountry") {
        this.setState({ countryRequired: false })
      }
    });
  };

  onChangeDate = ({ target }) => {
    this.setState({ [target.name]: target.value }, () => {
      if (target.name === "from") {
        this.setState({ monthRequired: false })
      }
    });
  };


  render() {
    const { t, history, validatePermissionAction, countriesCurrentCatalog } = this.props;
    const { fullData, data, loadingTable, loadingBtn1, loadingBtn2, lazyParams, typeProcess, typeCountry, countryRequired, from, monthRequired, searchValues } = this.state;

    let minDate = new Date();
    minDate.setMonth(0);
    minDate.setFullYear(2021);

    let maxDate = new Date();
    maxDate.setMonth(11);

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        <Button
          label={t('Regresar')}
          className="p-button-primary"
          onClick={() => history.push('/reports')}
        />
      </>
    );

    const renderDescriptionText = () => {
      if (typeProcess?.id === TypeProcess.PDD) {
        return (
          <p>{t('Detalle de folios')}</p>
        )
      }
      if (typeProcess?.id === TypeProcess.PDDC) {
        return (
          <p>{t('Detalle de folios')}</p>
        )
      }
      if (typeProcess?.id === TypeProcess.PCI) {
        return (
          <p>{t('Detalle de folios')}</p>
        )
      }
      if (typeProcess?.id === TypeProcess.PRGEH) {
        return (
          <p>{t('Total de folios por subproceso de regalos')}</p>
        )
      }
    }

    const renderBtnProcess = () => {
      switch (typeProcess?.id) {
        case TypeProcess.PDD:
          return (
            <div className="p-text-right ">
              {validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                <Button
                  label={t('Detalle de folios')}
                  className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4"
                  onClick={this.onDetailPDD}
                  loading={loadingBtn1}
                  icon='pi pi-download'
                // tooltip='Descarga xls'
                />
              )}
            </div>
          )
        case TypeProcess.PDDC:
          return (
            <div className="p-text-right ">
              {validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                <Button
                  label={t('Detalle de folios')}
                  className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4"
                  onClick={this.onDetailPDDC}
                  loading={loadingBtn1}
                  icon='pi pi-download'
                // tooltip='Descarga xls'
                />
              )}
            </div>
          )
        case TypeProcess.PCI:
          if (searchValues?.country != '' && searchValues?.monthYear != '') {
            return (
              <div className="p-text-right ">
                {validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                  <Button
                    label={t('Detalle de folios')}
                    className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4"
                    onClick={this.onDetailPCI}
                    loading={loadingBtn1}
                    icon='pi pi-download'
                  // tooltip='Descarga xls'
                  />
                )}
              </div>
            )
          } else {
            return (
              <br></br>
            );
          }

        case TypeProcess.PRGEH:
          return (
            <div className="p-text-right ">
              <Button
                label={t('Total de folios')}
                className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4 p-mr-3"
                onClick={this.onTotalPRGEH}
                loading={loadingBtn1}
                icon='pi pi-download'
              // tooltip='Descarga xls'
              />
              {validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                <Button
                  label={t('Detalle de folios')}
                  className="p-button p-button-outlined p-button-secondary p-component p-button-rounded p-mt-3 p-mb-4"
                  onClick={this.onDetailPRGEH}
                  loading={loadingBtn2}
                  icon='pi pi-download'
                // tooltip='Descarga xls'
                />
              )}
            </div>
          )
        default:
          return ""
      }
    }

    const renderTable = () => {
      if (typeProcess?.id === TypeProcess.PRGEH) {
        return (
          <DataTable
            value={data}
            lazy
            loading={loadingTable}
            onPage={this.onPage}
            paginator={!!fullData.length}
            rows={lazyParams.rows}
            totalRecords={fullData.length}
            first={lazyParams.first}
            showGridlines
            stripedRows
          >
            <Column
              header={t('País')}
              field="pais"
              body={this.columnResponsive}
            />
            <Column
              header={t('Subproceso')}
              field="subproceso"
              body={this.columnResponsive}
            />
            <Column
              header={t('Total')}
              field="total"
              body={this.columnResponsive}
            />
          </DataTable>
        )
      }
      if (typeProcess?.id === TypeProcess.PDD) {
        return (
          <DataTable
            value={data}
            lazy
            loading={loadingTable}
            onPage={this.onPage}
            paginator={!!fullData.length}
            rows={lazyParams.rows}
            totalRecords={fullData.length}
            first={lazyParams.first}
            showGridlines
            stripedRows
          >
            <Column
              header={t('País')}
              field="pais"
              body={this.columnResponsive}
            />
            <Column
              header={t('Folio')}
              field="folio"
              body={this.columnResponsive}
            />
            <Column
              header={t('Estatus')}
              field="estatus"
              body={this.columnResponsive}
            />
            <Column
              header={t('Evaluador')}
              field="evaluador"
              body={this.columnResponsive}
            />
          </DataTable>
        )
      }
      if (typeProcess?.id === TypeProcess.PDDC) {
        return (
          <DataTable
            value={data}
            lazy
            loading={loadingTable}
            onPage={this.onPage}
            paginator={!!fullData.length}
            rows={lazyParams.rows}
            totalRecords={fullData.length}
            first={lazyParams.first}
            showGridlines
            stripedRows
          >
            <Column
              header={t('País')}
              field="pais"
              body={this.columnResponsive}
            />
            <Column
              header={t('Folio')}
              field="folio"
              body={this.columnResponsive}
            />
            <Column
              header={t('Estatus')}
              field="estatus"
              body={this.columnResponsive}
            />
            <Column
              header={t('Evaluador')}
              field="evaluador"
              body={this.columnResponsive}
            />
          </DataTable>
        )
      }
      if (typeProcess?.id === TypeProcess.PCI) {
        let dataPCI = null;
        if (searchValues?.country != '' && searchValues?.monthYear != '') {
          dataPCI = (
            <DataTable
              value={data}
              lazy
              loading={loadingTable}
              onPage={this.onPage}
              paginator={!!fullData.length}
              rows={lazyParams.rows}
              totalRecords={fullData.length}
              first={lazyParams.first}
              showGridlines
              stripedRows
            >
              <Column
                header={t('País')}
                field="pais"
                body={this.columnResponsive}
              />
              <Column
                header={t('Empleado')}
                field="empleado"
                body={this.columnResponsive}
              />
              <Column
                header={t('Folio')}
                field="folio"
                body={this.columnResponsive}
              />
              <Column
                header={t('Estatus')}
                field="estatus"
                body={this.columnResponsive}
              />
              <Column
                header={t('Oficial Cumplimiento')}
                field="oc"
                body={this.columnResponsive}
              />
            </DataTable>
          );
        }

        return (
          <>
            <div className="p-grid">
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <label className="p-mr-2 p-text-bold">{t('País')}:</label>
                <Dropdown
                  name="typeCountry"
                  value={typeCountry}
                  options={countriesCurrentCatalog}
                  onChange={this.onChangeCountry}
                  optionLabel="label"
                  filter
                  // showClear
                  filterBy="label"
                  placeholder=""
                  style={{ width: '100%' }}
                  className={classNames({
                    'p-invalid': countryRequired,
                  })}
                />
              </div>
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <label className="p-mr-2 p-text-bold">{t('Mes')}:</label>
                <Calendar
                  name="from"
                  value={from}
                  onChange={this.onChangeDate}
                  view="month"
                  dateFormat="mm/yy"
                  showIcon
                  maxDate={maxDate}
                  minDate={minDate}
                  style={{ width: '100%' }}
                  readOnlyInput
                  className={classNames({
                    'p-invalid': monthRequired,
                  })}
                />
              </div>
              <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
                <Button
                  icon="pi pi-search"
                  label={t('Buscar')}
                  className="p-button-raised p-button-text p-button-plain btn-search-list"
                  onClick={() => this.searchData()}
                />
              </div>
            </div>
            {dataPCI}
          </>
        )
      }
    }

    return (
      <div className="p-grid p-justify-center">
        <div className="p-col-12">
          <Header title={t('Procesos')} rightComponent={rightHeader} />
          {renderDescriptionText()}
        </div>

        <div className="p-col-12 p-lg-8 p-mt-2">
          <div className="card">
            <div className='p-pb-1'>
              <label className="">{t('Tipo de proceso')}:</label>
              <Dropdown
                name="typeProcess"
                value={typeProcess}
                options={this.typeProcessOptions}
                onChange={this.onChangeProcess}
                optionLabel="label"
                className="p-mt-2"
                // filter
                // showClear
                // filterBy="label"
                placeholder=""
                style={{ width: '100%' }}
              />
            </div>
            {renderBtnProcess()}
            {renderTable()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog
});

const mapDispatchToProps = {
  getReportTotalFoliosPRGEH,
  getReportTotalFoliosPDD,
  getReportTotalFoliosPDDC,
  getReportTotalFoliosPCI,
  reportDetailPCI,
  reportTotalPRGEH,
  reportDetailPRGEH,
  reportDetailPDD,
  reportDetailPDDC,
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ReportsProces);
